/**
 * Quién es admin y quién es dueño, igual que en server/src/utils/roles.js.
 *
 * Hay dos marcas de admin: el rol `ADMIN` y `isAdmin`. Cualquiera de las dos
 * alcanza. `isAdmin` llega en /api/auth/me pero no en la respuesta del login,
 * así que justo después de loguearse puede faltar: el server igual decide.
 */
export interface RoleUser {
  role?: string | null;
  isAdmin?: boolean | null;
}

export const isAdminUser = (user?: RoleUser | null): boolean =>
  !!user && (user.role === 'ADMIN' || user.isAdmin === true);

/** VENUE_OWNER o BOTH (dueño que además juega). */
export const isVenueOwnerUser = (user?: RoleUser | null): boolean =>
  !!user && (user.role === 'VENUE_OWNER' || user.role === 'BOTH');
